import { observer } from 'mobx-react-lite'
import classNames from 'classnames'
import { Button, DropdownGroup, DropdownTextInput, Scrollbar, Typography } from 'shared/ui'
import type { GoogleCalendarPickerStore } from 'pages/chatbot/ui/UnifiedAgent/ui/BookingSection/store/googleCalendarPickerStore'
import styles from './styles.module.scss'

type IGoogleCalendarDropdownCustomComponentProps = {
  googleCalendarPickerStore: GoogleCalendarPickerStore
  onClose: () => void
  onSelectCalendar: () => void
  isTopReverse?: boolean
}

export const GoogleCalendarDropdownCustomComponent = observer(
  ({
    googleCalendarPickerStore,
    onClose,
    onSelectCalendar,
    isTopReverse,
  }: IGoogleCalendarDropdownCustomComponentProps) => {
    const {
      search,
      setSearch,
      calendarGroups,
      setGoogleCalendar,
      connectAccount,
      isGoogleAccountConnecting,
    } = googleCalendarPickerStore

    const hasCalendars = calendarGroups.some((group) => group.items.length > 0)

    return (
      <div
        className={classNames(styles.content, {
          'top-dropdown-column-reverse-content': isTopReverse,
        })}
      >
        <DropdownTextInput
          textFieldProps={{
            value: search,
            onChange: setSearch,
            InputProps: {
              placeholder: 'Search',
            },
          }}
          ariaLabel='searchGoogleCalendars'
        />
        <div className={styles.addAccountWrap}>
          <Button
            typeBtn='informative'
            contained='tertiary'
            icon={'add'}
            text={'Add account'}
            loading={isGoogleAccountConnecting}
            fullWidth
            className={styles.addAccountButton}
            onClick={connectAccount}
            iconProps={{
              color: 'var(--light-blue-60)',
            }}
          />
        </div>
        <Scrollbar autoHeight autoHeightMax={270}>
          {hasCalendars ? (
            calendarGroups.map(
              ({ account, items }) =>
                items.length > 0 && (
                  <DropdownGroup
                    key={account.external_user_id}
                    title={account.email}
                    items={items}
                    onChange={(item) => {
                      if (item.disabled) return
                      setGoogleCalendar(item)
                      onSelectCalendar()
                      onClose()
                    }}
                    stylesWrap={{ padding: '4px' }}
                    isScroll={false}
                  />
                )
            )
          ) : (
            <div className={styles.notFound}>
              <Typography
                variant={'body-md-regular'}
                ariaLabel={'NoResult'}
                color={'var(--content-primary-tertiary)'}
              >
                No calendars found
              </Typography>
            </div>
          )}
        </Scrollbar>
      </div>
    )
  }
)
